export class Deferred<T> {
	promise: Promise<T>;
	resolve: (obj: T) => void;
	reject: (err: Error) => void;

	constructor() {
		this.promise = new Promise((resolve, reject) => {
			this.resolve = resolve;
			this.reject = reject;
		});
	}

	static create<T>() {
		return new Deferred<T>();
	}
}
